import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import { MemberContext } from "../AllMemberComponent";
import { useForm } from "react-hook-form";
import { memberCollectionAction, organizationAction } from "../../../Redux/Action/MemberAction";
import { Button, Col, Form, Row } from "react-bootstrap";
import Regex from "../../../Utilities/Regex";
import DonationForm from "./DonationForm";
import { useNavigate } from 'react-router-dom';

function DonationComponent(props) {
    // ref
    const btnRef = useRef()
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const {
        setAllMemberReload,
        setDonationModelShow,
        getSingleMemberData,
        yearForPayment,
        setYearForPayment,
        organization,
        setOrganization
    } = useContext(MemberContext)

    //state
    const [organizationList, setOrganizationList] = useState([])

    const { watch, control, register, handleSubmit, getValues, reset, setValue, formState: { errors } } = useForm();
    // console.log(JSON.stringify(organization))

    const purpose = watch("purpose");

    // making active years lifecycle
    useEffect(() => {
        const payload = {
            setOrganizationList
        }

        dispatch(organizationAction(payload))

    }, [setOrganizationList])

    // console.log(getSingleMemberData)


    const onSubmit = data => {
        const payload = {
            data: {
                ...data,
                member_id: getSingleMemberData.id,
                organization_id: organization.id,
                agent_id: getSingleMemberData.agent_id,
                paymeny_type: collectionType === "Promised" ? "" : data.paymeny_type,


            },

            btnRef,
            setAllMemberReload,
            setDonationModelShow,
            setOrganization,
            navigate

        }
        dispatch(memberCollectionAction(payload))


    }
    const collectionType = watch('collection_type');

    return (
        <>{Object.keys(organization).length == 0 ? <><div className='org'>
            {organizationList.map((singleOrg, index) => (
                <Button key={index} value={singleOrg} onClick={(e) => setOrganization(singleOrg)}> {singleOrg.organization_name}</Button>

            ))}
        </div></> : ""}


            <form onSubmit={handleSubmit(onSubmit)} className='donation'>
                {Object.keys(organization).length ? <>
                    <Row>
                        <Col md={12} sm={12}>
                            <h5>{organization ? organization.organization_name : ""} </h5></Col>
                        <Col md={12} sm={12}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Purpose</Form.Label>
                                <Form.Select
                                    aria-label="Default select example"
                                    {...register("purpose", { required: true })}
                                    defaultValue=""  // ensures the first option is shown initially
                                >
                                    <option value="" disabled>
                                        Select
                                    </option>
                                    <option value="General">General</option>
                                    <option value="Orphanage Fund">Orphanage Fund</option>
                                    <option value="Other">Other's</option>
                                </Form.Select>

                                {/* validation message*/}
                                {errors.purpose && <span className="text-danger">
                                    {errors.purpose.type === "required" && "Please Give purpose"}
                                </span>}
                            </Form.Group>

                        </Col>
                        {purpose === "Other" ? (
                            <>

                                <Col md={12} sm={12}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Goods name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            {...register("goods", {
                                                required: true

                                            })}
                                        />

                                        {/* validation message*/}
                                        {errors.goods && <span className="text-danger">
                                            {errors.goods.type === "required" && "Please Give Amount"}
                                        </span>}
                                    </Form.Group>

                                </Col>
                                <Col md={12} sm={12}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Quantity</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="00"
                                            {...register("quantity", {
                                                required: true,
                                            })}
                                        />

                                        {/* validation message*/}
                                        {errors.quantity && <span className="text-danger">
                                            {errors.quantity.type === "required" && "Please Give Amount"}
                                        </span>}
                                    </Form.Group>

                                </Col>

                            </>
                        ) : (
                            ""
                        )}
                        <Col md={12} sm={12}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Collection type</Form.Label>
                                <Form.Select
                                    aria-label="Default select example"
                                    {...register("collection_type", { required: true })}
                                    defaultValue=""  // ensures the first option is shown initially
                                >
                                    <option value="" disabled>
                                        Select
                                    </option>
                                    <option value="Cash collection">Pay</option>
                                    <option value="Promised">Promised</option>

                                </Form.Select>

                                {/* validation message*/}
                                {errors.collection_type && <span className="text-danger">
                                    {errors.collection_type.type === "required" && "Please select collection type"}
                                </span>}
                            </Form.Group>

                        </Col>
                    </Row>


                    <Row>
                        {collectionType === "Cash collection" && (
                            <Col md={12} sm={12}>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Paymeny type</Form.Label>
                                    <Form.Select
                                        aria-label="Default select example"
                                        {...register("paymeny_type", { required: true })}
                                        defaultValue=""  // ensures the first option is shown initially
                                    >
                                        <option value="" disabled>
                                            Select
                                        </option>
                                        <option value="Cash">Cash</option>
                                        <option value="Online Pay">Online </option>
                                        <option value="Check">Check </option>

                                    </Form.Select>

                                    {/* validation message*/}
                                    {errors.paymeny_type && <span className="text-danger">
                                        {errors.paymeny_type.type === "required" && "Please select type"}
                                    </span>}
                                </Form.Group>
                            </Col>

                        )}




                        <Col md={12} sm={12}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Amount</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="00"
                                    {...register("collection_amount", {
                                        required: true,
                                        min: {
                                            value: 500,
                                            message: "Minimum amount is 500"
                                        },
                                        pattern: Regex.numeric()
                                    })}
                                />

                                {/* validation message */}
                                {errors.collection_amount && (
                                    <span className="text-danger">
                                        {errors.collection_amount.type === "required" && "Please give amount"}
                                        {errors.collection_amount.type === "min" && "Minimum amount is 500"}
                                        {errors.collection_amount.type === "pattern" && "Please enter a valid number"}
                                    </span>
                                )}
                            </Form.Group>

                        </Col>
                    </Row>
                    <Button ref={btnRef} variant="primary" type="submit" className="submit">
                        Submit
                    </Button>
                </> : ""}

            </form>


        </>
    );
}

export default DonationComponent;